import {
    AGENT_AT_CREATION,
    AGENT_DETAILS_PAGE,
    CO_SELLER_DIS_PAGE,
    SELLER_EDIT_DIS_PAGE,
    SELLER_HOMED_PAGE,
    SELLER_UPSELL_PAGE,
    SELLER_DIS_UP_PAGE,
    SELLER_DIS_UP_EDIT
} from "@sellers-shield-home-protection/ss-core-js/src/AppResources/LuHslpUpsellPaymentFromAppResource";

export const pageId = (route, isAgent) => {

    let fromId;
    switch (route) {
        case 'invite-seller' :
            fromId = AGENT_AT_CREATION; // 11010; //Agent Purchased at order creation //ok
            break;
        case 'dashboard' :
            if (isAgent) {
                fromId = AGENT_DETAILS_PAGE; // 11020; //Agent clicked button on listing details page //ok
            } else {
                fromId = SELLER_HOMED_PAGE; //11070; //Seller clicked button on home details page //ok
            }
            break;
        case 'order-details' :
            if (isAgent) {
                fromId = AGENT_DETAILS_PAGE; //11020; //Agent clicked button on listing details page
            } else {
                fromId = SELLER_HOMED_PAGE; //11070; //Seller clicked button on home details page
            }
            break;
        case 'order-disclosure-risk' :
            fromId = SELLER_UPSELL_PAGE; //11030; //Seller clicked button on pre eula upsell page
            break;
        case 'disclosure-upsell' :
        case 'order-disclosure-form' :
            fromId = SELLER_EDIT_DIS_PAGE; //11040; //Seller clicked button on edit disclosure page
            break;
        case 'sign-disclosure' :
        case 'download-pdfs' :
            fromId = CO_SELLER_DIS_PAGE; //11080; //Co Seller on post disclosure upsell page
            break;
        default:
            fromId = null;
    }

    return fromId;
};

export const pageIdwithStatus = (route, isAgent, orderAppResource) => {
    let fromId = pageId(route, isAgent);
    if(fromId == SELLER_EDIT_DIS_PAGE){
        fromId = orderAppResource.signDisclosure.isEmpty ? SELLER_DIS_UP_PAGE : SELLER_DIS_UP_EDIT;
    }
    return fromId;
}